/**
 * Partial re-pricing from the cost-sheet page (JF 2026-09-29): refresh (free) / cm / line / all.
 * Keeps the sheet before the change for one-click undo and reports "FOB before → after".
 */
import { f2, totals, type Lang } from "@ic/engine";
import { useStore } from "../../store.ts";
import { tFor } from "../../shared/i18n.ts";
import { api } from "../../shared/api.ts";
import { withAiBase } from "./aiBase.ts";

export type Task = "refresh" | "cm" | "line" | "all";

export async function runTask(task: Task, lang: Lang, extra: { kind?: "fab" | "trim"; i?: number; note?: string } = {}): Promise<boolean> {
  const { sheet, setSheet, setUndo, toast, meta } = useStore.getState();
  const t = tFor(lang);
  const demo = !!(sheet.ai && sheet.ai.demo);
  const body = { task, sheet, lang, ...extra };
  try {
    if (task !== "refresh" && !demo && !meta?.ai.configured) {
      toast(t("AI is not configured on the server — ask the administrator.", "服务器还没配置 AI——请联系管理员。"));
      return false;
    }
    const r = await api.task(body);
    if (task === "refresh") { setSheet(r.sheet); return true; }
    const before = totals(sheet).fob, after = totals(r.sheet).fob;
    // a full re-pricing is a new AI result to reset to; a CM / one-row re-estimate keeps the earlier one
    if (task === "all") withAiBase(r.sheet);
    else if (sheet.ai?.base && r.sheet.ai && !r.sheet.ai.base) r.sheet.ai.base = sheet.ai.base;
    const label = { cm: t("CM re-estimated", "重估 CM"), line: t("row re-estimated", "单行重估"), all: t("re-priced from the checklist", "按清单重新定价") }[task];
    setUndo({ sheet, label });
    setSheet(r.sheet);
    toast(`${label}: FOB $${f2(before)} → $${f2(after)}`);
    return true;
  } catch (e) {
    toast(e instanceof Error ? e.message : String(e));
    return false;
  }
}
